import React, { useState, useRef, useEffect } from 'react';
import PreviewHeader from './PreviewHeader';
import PreviewContent from './PreviewContent';
import PreviewBottom from './PreviewBottom';

const ORIGINAL_WIDTH = 348;

const Preview = ({ resumeData, resumeTitle }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const previewRef = useRef(null);
  const pdfCaptureRef = useRef(null);
  const wrapperRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      const containerWidth = entry.contentRect.width;
      setScale(containerWidth / ORIGINAL_WIDTH);
    });

    if (wrapperRef.current) observer.observe(wrapperRef.current);
    return () => observer.disconnect();
  }, []);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div
      ref={wrapperRef}
      className='w-full min-w-[273px] max-w-[380px] flex flex-col items-start px-4 gap-4'
    >
      <PreviewHeader
        currentPage={currentPage}
        totalPages={totalPages}
        onPrev={handlePrev}
        onNext={handleNext}
      />

      <div
        style={{
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          width: `${ORIGINAL_WIDTH}px`,
        }}
        className='flex flex-col gap-4 w-full max-w-[348px]'
      >
        <PreviewContent
          ref={previewRef}
          resumeData={resumeData}
          setTotalPages={setTotalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />

        <PreviewBottom
          previewRef={previewRef}
          resumeData={resumeData}
          resumeTitle={resumeTitle}
          setTotalPages={setTotalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pdfCaptureRef={pdfCaptureRef}
        />
      </div>
    </div>
  );
};

export default Preview;
